import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import serverInterface from 'server-interface';

import HelptapEditor from '../../helpers';

const PAGE_SIZE = 30;

function buildRowStyleBlock(node, containerId) {

  const firstRow = node.children[0];
  const rowSelector = `#${containerId} > .data-collection-row`;
  const rowStyles = basicEditorValueSerializer.stylers.getNodeStyles(firstRow);
  const rowHoverStyles = basicEditorValueSerializer.stylers.getNodeHoverStyles(firstRow);

  let block = `${rowSelector} { ${rowStyles} }`;

  if (rowHoverStyles !== '') {
    block = `${block} ${rowSelector}:hover { ${rowHoverStyles} }`;
  }

  return `<style>${block}</style>`;

}

function buildRowsHTML(node, rows) {

  const properties = node.properties;
  const children = basicEditorValueSerializer.utilities.node.dataCollection.buildRows(properties.columns, properties.template, rows);

  return basicEditorValueSerializer.toHTML(children);

}

function determineLimit(node, shownCount) {

  const limit = shownCount + PAGE_SIZE;

  if (limit > node.properties.rowsCount) {
    return node.properties.rowsCount;
  }

  return limit;

}

export function hasMoreThanPreview(node) {

  if (node.children.length < HelptapEditor.dataCollection.PREVIEW_ROWS_COUNT) {
    return false;
  }

  return node.properties.rowsCount > node.children.length;

}

export function buildMoreRowsHTML(node, containerId, rowsHTML) {

  return buildRowStyleBlock(node, containerId) + rowsHTML;

}

export async function fetchMoreRows(pageId, node, shownCount) {

  const limit = determineLimit(node, shownCount);

  const rows = await serverInterface.startup.pages.getRecordsForPageAndDataCollectionNode(pageId, {
    ...node,
    properties: {
      ...node.properties,
      rowsCount: limit
    }
  });

  const newRows = rows.slice(shownCount);

  let hasMore = false;

  if (rows.length === limit && limit < node.properties.rowsCount) {
    hasMore = true;
  }

  return {
    html: buildRowsHTML(node, newRows),
    count: newRows.length,
    hasMore
  };

}
